import React from 'react';
import { connect } from 'react-redux';
import Loader from 'react-loader-spinner';

import { moment } from 'i18n';
import styles from './Table.module.scss';
import { TableWrapper } from 'containers/Tables';
import { cancelOrder } from 'redux/actions/orders';
import { formatCrypto } from 'utils/numbers';
import { withNamespaces } from 'react-i18next';
import { nestedTranslate } from 'utils/strings';
import { Box, ButtonNew, Text } from 'components/Wrapped';
import { formatNumberToPlaces } from 'utils';

class OpenOrdersTable extends React.PureComponent {
  renderSide = (t) => ({ value }) => {
    const color = value === 'BUY' ? '#46B08E' : '#C55445';

    return (
      <Text color={color} size="12px" weight={600}>
        {value === 'BUY' ? 'Купить' : 'Продать'}
        {/* {t('orderSide', { side: value[0] + value.slice(1).toLowerCase() })} */}
      </Text>
    );
  };

  renderExecutePriceOrder({ value }) {
    return (
      <Box pad="none">
        <Text size="12px" weight={600}>
          {formatCrypto(value.firstValue, true)}
        </Text>
        {value.secondValue && (
          <Text size="12px" weight={600}>
            {formatCrypto(value.secondValue, true)}
          </Text>
        )}
      </Box>
    );
  }

  renderExecutedVolume({ value: { base, pendingVolume, volume } }) {
    return (
      <Box pad="none">
        <Text size="12px" weight={600}>
          {formatCrypto(volume - pendingVolume, true)} {base}
        </Text>
        <Text size="12px" weight={600}>
          {formatCrypto(volume, true)} {base}
        </Text>
      </Box>
    );
  }

  renderSumOrder({ value: { quote, price, pending, volume } }) {
    return (
      <Box pad="none">
        <Text size="12px" weight={600}>
          {formatNumberToPlaces((volume - pending) * price)} {quote}
        </Text>
        <Text size="12px" weight={600}>
          {formatNumberToPlaces(volume * price)} {quote}
        </Text>
      </Box>
    );
  }

  renderOrderStatus({ value }) {
    if (value === 'NewOrder') {
      return (
        <Text size="12px" weight={600}>
          Новый
        </Text>
      );
    }

    if (value === 'PartiallyFilled') {
      return (
        <Text size="12px" weight={600}>
          Частично исполнено
        </Text>
      );
    }

    if (value === 'Filled') {
      return (
        <Text size="12px" weight={600}>
          Исполнено
        </Text>
      );
    }

    return (
      <Text size="12px" weight={600}>
        Отменено
      </Text>
    );
  }

  renderOrderNumber({ value }) {
    if (!value) {
      return '';
    }

    const orderId = value.toString();

    return (
      <Text size="12px" weight={600}>
        {orderId.slice(0, 3) + '...' + orderId.slice(-3)}
      </Text>
    );
  }

  renderNumber({ value }) {
    return formatCrypto(value, true);
  }

  renderSymbol({ value }) {
    return (
      <Text size="12px" weight={600}>
        {value}
      </Text>
    );
  }

  renderDate({ value }) {
    return (
      <Box pad="none">
        <Text color="#B4B6B7" size="12px" weight={600}>
          {moment(value).format('DD.MM.YYYY')}
        </Text>
        <Text color="#B4B6B7" size="12px" weight={600}>
          {moment(value).format('HH:mm:ss')}
        </Text>
      </Box>
    );
  }

  renderAction = (translate, cancelableOrderId) => ({ original, row: { orderId } }) => {
    return (
      <Box pad="none" align="end">
        <ButtonNew
          theme="gray"
          disabled={Boolean(cancelableOrderId)}
          buttonSize="medium"
          label={
            <Box pad="none" gap="5px" align="center" direction="row">
              {cancelableOrderId === orderId && (
                <div style={{ display: 'flex', height: '16px' }}>
                  <Loader type="Oval" color="white" strokeWidth="4" height="16" width="16" />
                </div>
              )}
              <Text style={{ lineHeight: '20px' }}>Отменить</Text>
            </Box>
          }
          height="30px"
          width="120px"
          onClick={this.handleCancelOrder(original)}
        />
      </Box>
    );
  };

  handleCancelOrder = (data) => () => {
    this.props.cancelOrder(data);
  };

  render() {
    const { t: translate, cancelableOrderId } = this.props;
    const t = nestedTranslate(translate, 'tables.openOrdersTable');

    return (
      <TableWrapper
        data={this.props.openOrders}
        isFilterable={true}
        headOpacity="1"
        resizable={false}
        columns={[
          {
            Header: 'Символ',
            accessor: 'tradingPair',
            Cell: this.renderSymbol,
          },
          {
            // Header: t('date'),
            Header: 'Дата',
            accessor: 'date',
            Cell: this.renderDate,
          },
          {
            Header: 'Тип',
            accessor: 'orderSide',
            Cell: this.renderSide(t),
          },
          {
            Header: 'Исполнение | Цена ордера',
            id: 'price',
            accessor: ({ price }) => ({ firstValue: '-', secondValue: price }),
            Cell: this.renderExecutePriceOrder,
          },
          {
            Header: 'Исполнено | Всего',
            id: 'executed_volume',
            accessor: (data) => data,
            Cell: this.renderExecutedVolume,
          },
          {
            Header: 'Исполнено | Сумма ордера',
            id: 'sum_order',
            accessor: (data) => data,
            Cell: this.renderSumOrder,
          },
          {
            Header: 'Статус ордера',
            accessor: 'orderStatus',
            Cell: this.renderOrderStatus,
          },
          {
            Header: 'Номер',
            accessor: 'orderId',
            Cell: this.renderOrderNumber,
          },
          {
            Header: 'Отменить все',
            headerClassName: styles.columnRight,
            id: 'action',
            accessor: (data) => data,
            Cell: this.renderAction(translate, cancelableOrderId),
          },
        ]}
        style={{ height: '100%' }}
        sortable={false}
        showPagination={false}
        pageSize={this.props.openOrders.length || 0}
        {...this.props.extraProps}
      />
    );
  }
}

const mapStateToProps = ({ orders }) => ({
  openOrders: orders.openOrders,
  cancelableOrderId: orders.cancelableOrderId,
});

const mapDispatchToProps = {
  cancelOrder,
};

export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(OpenOrdersTable));
